import * as typesUser from '../types/user';
import { UserAction, ReplaceUserActionTypes, UserType } from '../types';
const initialState: UserType = {
  googleId: "",
    imageUrl: "",
    email: "",
    name: "",
    givenName:"",
    familyName: "",
    isLogged: false,
    teamRole: "",
    league: "",
    tokenId: "",
    id: "",
    insightRole: "",
    permissions: [],
    teamName: "",
    teamShort: "",
    teamId: "",
    sbRole: ""
};
export const user = (state = initialState, action: ReplaceUserActionTypes) => {
  switch (action.type) {
    case UserAction.REPLACE_USER:
      if (JSON.stringify(state) !== JSON.stringify(action.user)) {
        return { ...action.user };
      }
      return state;
    default:
      return state;
  }
};
